import React from 'react';

export type ExpenseType = '지출기록' | '송금기록';

interface ExpenseTypeSelectProps {
  expenseType: ExpenseType;
  onChange: (type: ExpenseType) => void;
  disabled?: boolean;
}

const ExpenseTypeSelect: React.FC<ExpenseTypeSelectProps> = ({
  expenseType,
  onChange,
  disabled = false
}) => {
  return (
    <div className="mt-1 rounded-xl p-1.5 select-none w-full flex justify-around items-center bg-gray-50 mb-6">
      <button
        className={`w-full py-2 text-sm rounded-lg font-bold ${expenseType === '지출기록' ? 'text-white bg-blue-500' : 'text-gray-800'}`}
        onClick={() => onChange('지출기록')}
        disabled={disabled && expenseType === '송금기록'}
      >
        지출 등록
      </button>
      <button
        className={`w-full py-2 text-sm rounded-lg font-bold ${expenseType === '송금기록' ? 'text-white bg-blue-500' : 'text-gray-800'}`}
        onClick={() => onChange('송금기록')}
        disabled={disabled && expenseType === '지출기록'}
      >
        송금 등록
      </button>
    </div>
  );
};

export default ExpenseTypeSelect; 